import { gql } from '@apollo/client';

export const GET_VOLUNTEER_ACHIEVEMENTS = gql`
  query GetVolunteerAchievements($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        awardedAchievements(includeRevoked: true) {
          awardedAchievementId
          source
          awardedAt
          valueAtAward
          note
          isRevoked
          revokedAt
          awardedBy {
            volunteerId
            profile {
              profileId
              preferredName
              lastName
            }
          }
          revokedBy {
            volunteerId
            profile {
              profileId
              preferredName
              lastName
            }
          }
          level {
            achievementLevelId
            name
            badgeDesign
            achievement {
              achievementId
              name
              metric
            }
          }
        }
      }
      achievements {
        achievementId
        name
        isEnabled
        levels {
          achievementLevelId
          name
          position
          badgeDesign
        }
      }
    }
  }
`;
